// generated from 54_871 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const receivedCampaignFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("received_campaign_filter"),
  comparison_key: z.enum([
    "8", // 42_047 (76.63%)
    "7", // 12_824 (23.37%)
  ]),
  display_name: z.string(),
  // undefined: 19_602 (35.72%), defined 35_269 (64.28%)
  raw_value: common.objectId.optional(),
  value: z.object({
    // true 13_547 (24.69%), false 41_324 (75.31%)
    expired: z.boolean(),
    id: common.objectId,
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
